var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "tipPaymentModal",
        "modal-class": "tip-payment-modal",
        title: "Enter Gratuity",
        centered: "",
        "hide-footer": "",
        size: "md",
      },
      model: {
        value: _vm.showModal,
        callback: function ($$v) {
          _vm.showModal = $$v
        },
        expression: "showModal",
      },
    },
    [
      _vm.tipTab.stats
        ? _c(
            "b-row",
            { staticClass: "pt-4" },
            [
              _c(
                "b-col",
                { staticClass: "tip-guest-tab pr-0", attrs: { cols: "8" } },
                [
                  _c("guest-tab", {
                    ref: "tipGuestTab",
                    attrs: {
                      "component-id": "tip-guest-tab",
                      tab: _vm.tipTab,
                      "extra-tip": _vm.tip_amount,
                      "hide-header": true,
                      "show-description": false,
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "tip-amount-buttons" },
                [
                  _c(
                    "b-btn",
                    {
                      staticClass: "tip-amount-button",
                      attrs: { variant: "secondary" },
                      on: {
                        click: function ($event) {
                          return _vm.setTipAmount(_vm.tip_rate_1)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n        " + _vm._s(_vm.tip_rate_1) + " %\n      "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-btn",
                    {
                      staticClass: "tip-amount-button mt-3",
                      attrs: { variant: "secondary" },
                      on: {
                        click: function ($event) {
                          return _vm.setTipAmount(_vm.tip_rate_2)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n        " + _vm._s(_vm.tip_rate_2) + " %\n      "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-btn",
                    {
                      staticClass: "tip-amount-button mt-3",
                      attrs: { variant: "secondary" },
                      on: {
                        click: function ($event) {
                          return _vm.setTipAmount(_vm.tip_rate_3)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n        " + _vm._s(_vm.tip_rate_3) + " %\n      "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-btn",
                    {
                      staticClass: "tip-amount-button mt-3",
                      attrs: { variant: "secondary" },
                      on: {
                        click: function ($event) {
                          return _vm.showTipRateModal()
                        },
                      },
                    },
                    [_vm._v("\n        Other\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-btn",
                    {
                      staticClass: "tip-amount-button mt-3",
                      attrs: { variant: "success" },
                      on: {
                        click: function ($event) {
                          return _vm.approveTipAmount()
                        },
                      },
                    },
                    [_vm._v("\n        Approve\n      ")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { title: "Enter Tip Rate", centered: "", size: "sm" },
          model: {
            value: _vm.showInputRateModal,
            callback: function ($$v) {
              _vm.showInputRateModal = $$v
            },
            expression: "showInputRateModal",
          },
        },
        [
          _c(
            "b-form",
            [
              _c(
                "info-row",
                { staticClass: "info-main-row", attrs: { title: "Tip Rate" } },
                [
                  _c("currency-input", {
                    attrs: {
                      name: "Tip Rate",
                      "currency-symbol": "%",
                      size: 12,
                      amount: _vm.tip_rate,
                      fieldState: _vm.fieldState.tip_rate,
                    },
                    on: {
                      "update:amount": function ($event) {
                        _vm.tip_rate = $event
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "w-100",
              attrs: { slot: "modal-footer" },
              slot: "modal-footer",
            },
            [
              _c(
                "b-btn",
                {
                  staticClass: "float-right",
                  attrs: { variant: "success" },
                  on: {
                    click: function ($event) {
                      return _vm.setTipRate()
                    },
                  },
                },
                [_vm._v("\n        Set Tip Rate\n      ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }